<template>
  <v-container class="change-password-form" max-width="600">
    <v-card>
      <v-card-title class="text-h5">User Profile</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="updateProfile" ref="form">
          <div>
            <label>Registration code: {{ user.registrationCode }}</label>
          </div>
          <v-text-field
            v-model="user.name"
            label="Name"
            outlined
            :rules="[(v) => !!v || 'Name is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.email"
            label="Email"
            outlined
            :rules="[
              (v) => !!v || 'Email is required',
              (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
            ]"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.phone"
            label="Phone"
            outlined
            :rules="[(v) => !!v || 'Phone number is required']"
          ></v-text-field>
          <v-file-input
            label="Upload Signature"
            accept="image/*"
            :counter="false"
            :multiple="false"
            @change="onFileSelect"
            outlined
          ></v-file-input>
          <!-- Preview the uploaded signature -->
          <v-img
            v-if="previewUrl || user.signatureURL"
            :src="previewUrl || user.signatureURL"
            alt="Signature Preview"
            class="mt-3"
            max-height="150"
            contain
          ></v-img>
          <v-btn
            type="submit"
            class="mt-4 bg-green-darken-2 text-white"
            :disabled="!valid"
          >
            Update
          </v-btn>
        </v-form>
        <p v-if="message">{{ message }}</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "@/utils/api";
import { API_ROUTES } from "@/utils/apiConstants";

export default {
  data() {
    return {
      user: {
        name: "",
        email: "",
        phone: "",
        registrationCode: "",
        signatureFile: null,
      },
      previewUrl: null,
      valid: true, // Control form validity
      message: "",
    };
  },
  created() {
    this.fetchUserData();
  },
  methods: {
    async fetchUserData() {
      // Fetch user data from API if needed
      try {
        const response = await apiClient.get(API_ROUTES.GET_USER);
        this.user = response.data.user;
        this.$store.commit("auth/SET_USER", this.user);

        // Optional: update localStorage if you're syncing it
        localStorage.setItem("user", JSON.stringify(this.user));
      } catch (error) {
        console.error("Failed to load user data", error);
      }
    },
    async updateProfile() {
      const form = this.$refs.form;
      if (!form.validate()) return;
      try {
        const formData = new FormData();
        formData.append("id", this.user.id);
        formData.append("name", this.user.name);
        formData.append("email", this.user.email);
        formData.append("type", this.user.type); // if required
        if (this.user.phone) formData.append("phone", this.user.phone);
        if (this.user.center_id)
          formData.append("center_id", this.user.center_id);
        if (this.signatureFile)
          formData.append("signature", this.signatureFile);

        const response = await apiClient.post(
          API_ROUTES.UPDATE_USER,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.message =
          response.data.message || "User Profile updated successfully!";
        this.fetchUserData();
        // Update localStorage after successful update
      } catch (error) {
        this.message =
          "Error: " +
          (error.response?.data?.message || "Error updating profile!");
        console.error("Error updating profile", error);
      }
    },
    onFileSelect(event) {
      const files = event?.target?.files || event;
      const file = Array.isArray(files) ? files[0] : files?.[0] || files;

      if (file instanceof File) {
        this.signatureFile = file;
        this.previewUrl = URL.createObjectURL(file);
      } else {
        this.signatureFile = null;
        this.previewUrl = null;
      }
    },
  },
};
</script>

<style scoped>
.profile {
  max-width: 600px;
  margin: 0 auto;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
button {
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.change-password {
  margin-top: 20px;
}
.change-password a {
  color: #007bff;
  text-decoration: none;
}
</style>
